import React from 'react';

// 1. Accountability Over Convenience
export const AccountabilitySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="accGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
      <linearGradient id="accGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.1"/>
      </linearGradient>
    </defs>
    
    {/* Background circle */}
    <circle cx="60" cy="60" r="55" fill="url(#accGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Shield representing accountability */}
    <path d="M60 25 L80 38 L80 58 C80 72 72 82 60 88 C48 82 40 72 40 58 L40 38 L60 25Z" 
          fill="url(#accGrad2)" stroke="#0f3b5e" strokeWidth="2.5"/>
    
    {/* Inner shield */}
    <path d="M60 32 L74 41 L74 57 C74 68 68 76 60 80 C52 76 46 68 46 57 L46 41 L60 32Z" 
          fill="#0f3b5e" opacity="0.06"/>
    
    {/* Checkmark - indicating accountability done right */}
    <path d="M48 55 L56 64 L74 46" stroke="#22c55e" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* Small decorative dots */}
    <circle cx="42" cy="38" r="3" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="78" cy="38" r="3" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="42" cy="78" r="3" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="78" cy="78" r="3" fill="#0f3b5e" opacity="0.15"/>
    
    {/* Label */}
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">ACCOUNTABILITY</text>
  </svg>
);

// 2. Transparency From Day One
export const TransparencySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="transGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
      <radialGradient id="transGrad2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.2"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.02"/>
      </radialGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#transGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Eye - representing transparency */}
    <circle cx="60" cy="55" r="22" fill="url(#transGrad2)" stroke="#0f3b5e" strokeWidth="2"/>
    <circle cx="60" cy="55" r="16" fill="white" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="55" r="10" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="60" cy="55" r="6" fill="#0f3b5e" opacity="0.4"/>
    <circle cx="60" cy="55" r="3" fill="#0f3b5e" opacity="0.6"/>
    
    {/* Light rays - transparency */}
    <g stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3">
      <line x1="60" y1="28" x2="60" y2="22"/>
      <line x1="60" y1="82" x2="60" y2="88"/>
      <line x1="33" y1="55" x2="27" y2="55"/>
      <line x1="87" y1="55" x2="93" y2="55"/>
      <line x1="41" y1="36" x2="37" y2="32"/>
      <line x1="79" y1="36" x2="83" y2="32"/>
      <line x1="41" y1="74" x2="37" y2="78"/>
      <line x1="79" y1="74" x2="83" y2="78"/>
    </g>
    
    {/* No black box - cross through box */}
    <rect x="75" y="78" width="16" height="12" rx="1" fill="#0f3b5e" opacity="0.1" stroke="#ef4444" strokeWidth="1.5"/>
    <line x1="73" y1="76" x2="93" y2="92" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
    
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">TRANSPARENCY</text>
  </svg>
);

// 3. Sustainability at the Source
export const SustainabilitySourceSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="susGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#22c55e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#22c55e" stopOpacity="0.05"/>
      </linearGradient>
      <radialGradient id="susGrad2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#22c55e" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#22c55e" stopOpacity="0.02"/>
      </radialGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#susGrad)" stroke="#22c55e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#22c55e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Factory with leaf - sustainable production */}
    <rect x="44" y="55" width="32" height="25" rx="2" fill="#22c55e" opacity="0.1" stroke="#22c55e" strokeWidth="1.5"/>
    <rect x="48" y="62" width="6" height="8" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="58" y="62" width="6" height="8" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="68" y="62" width="6" height="8" rx="1" fill="#22c55e" opacity="0.2"/>
    
    {/* Chimney with green leaf/smoke */}
    <rect x="68" y="40" width="6" height="15" fill="#22c55e" opacity="0.2"/>
    <path d="M71 40 C66 35 62 30 55 32 C50 34 48 38 52 42" stroke="#22c55e" strokeWidth="2" fill="none" opacity="0.4"/>
    
    {/* Leaf symbolizing sustainability */}
    <path d="M30 45 C35 35 45 30 55 38 C62 44 65 55 58 62 C52 68 42 65 36 58 C30 52 28 48 30 45Z" 
          fill="#22c55e" opacity="0.15" stroke="#22c55e" strokeWidth="2"/>
    <path d="M30 45 L42 50" stroke="#22c55e" strokeWidth="1.5" opacity="0.4"/>
    
    {/* CO2 reduction arrow */}
    <text x="32" y="38" fontSize="7" fill="#22c55e" fontWeight="bold">CO₂</text>
    <path d="M36 36 L42 30 L48 36" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#22c55e" fontWeight="bold">SUSTAINABILITY</text>
  </svg>
);

// 4. Quality Is Non-Negotiable
export const QualityNonNegotiableSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="qualGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#qualGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Quality seal / badge */}
    <circle cx="60" cy="55" r="25" fill="none" stroke="#0f3b5e" strokeWidth="2.5"/>
    <circle cx="60" cy="55" r="20" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1" strokeDasharray="3 3"/>
    
    {/* Gear - engineering quality */}
    <g transform="translate(60, 55)" stroke="#0f3b5e" strokeWidth="2">
      <circle cx="0" cy="0" r="10" fill="white" strokeWidth="2.5"/>
      {[...Array(8)].map((_, i) => {
        const angle = (i / 8) * 2 * Math.PI;
        const x1 = 11 * Math.cos(angle);
        const y1 = 11 * Math.sin(angle);
        const x2 = 14 * Math.cos(angle);
        const y2 = 14 * Math.sin(angle);
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} strokeWidth="2.5"/>;
      })}
    </g>
    
    {/* Checkmark inside gear */}
    <path d="M54 55 L58 60 L66 52" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* "Non-negotiable" cross */}
    <text x="60" y="92" textAnchor="middle" fontSize="6" fill="#ef4444" fontWeight="bold">✕ NON-NEGOTIABLE</text>
    
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">QUALITY</text>
  </svg>
);

// 5. Partnership Over Transactions
export const PartnershipSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="partGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
      <linearGradient id="partGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.1"/>
      </linearGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#partGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Two hands shaking */}
    {/* Left hand */}
    <path d="M35 58 C30 52 32 42 40 40 C46 38 52 40 55 44" stroke="#0f3b5e" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="38" cy="48" r="4" fill="url(#partGrad2)" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Right hand */}
    <path d="M85 58 C90 52 88 42 80 40 C74 38 68 40 65 44" stroke="#0f3b5e" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="82" cy="48" r="4" fill="url(#partGrad2)" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Handshake center */}
    <circle cx="60" cy="50" r="12" fill="#0f3b5e" opacity="0.06"/>
    <circle cx="60" cy="50" r="7" fill="#0f3b5e" opacity="0.12"/>
    <circle cx="60" cy="50" r="3" fill="#0f3b5e" opacity="0.25"/>
    
    {/* Partnership arrows - circular growth */}
    <path d="M45 76 C50 82 58 85 65 82" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6"/>
    <path d="M75 76 C70 82 62 85 55 82" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6"/>
    <path d="M47 80 L45 76 L49 76" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6"/>
    <path d="M73 80 L75 76 L71 76" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6"/>
    
    {/* Long-term text */}
    <text x="60" y="95" textAnchor="middle" fontSize="5" fill="#0f3b5e" opacity="0.7">LONG-TERM</text>
    
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">PARTNERSHIP</text>
  </svg>
);

// 6. Simplicity Creates Impact
export const SimplicitySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="simpGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#simpGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Complex path (before) */}
    <path d="M30 45 C40 40 50 55 60 50 C70 45 80 60 90 55" stroke="#ef4444" strokeWidth="2" strokeDasharray="4 4" opacity="0.5"/>
    
    {/* Simple path (after) - clean straight line */}
    <path d="M30 65 L90 65" stroke="#22c55e" strokeWidth="3" strokeLinecap="round"/>
    
    {/* Arrow showing transformation */}
    <text x="55" y="52" fontSize="10" fill="#0f3b5e" opacity="0.5">→</text>
    
    {/* Simplified elements - removing complexity */}
    <circle cx="35" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    <circle cx="45" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    <circle cx="55" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    <circle cx="65" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    <circle cx="75" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    <circle cx="85" cy="58" r="3" fill="#ef4444" opacity="0.3"/>
    
    {/* Clean result */}
    <circle cx="60" cy="65" r="5" fill="#22c55e" opacity="0.3"/>
    <circle cx="60" cy="65" r="2" fill="#22c55e" opacity="0.6"/>
    
    {/* Impact icon */}
    <path d="M56 72 L60 68 L64 72" stroke="#0f3b5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M58 72 L62 72" stroke="#0f3b5e" strokeWidth="2" strokeLinecap="round"/>
    
    <text x="60" y="108" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">SIMPLICITY</text>
  </svg>
);

// 7. Continuous Improvement Always
export const ContinuousImprovementSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="contGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#0f3b5e" stopOpacity="0.05"/>
      </linearGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#contGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#0f3b5e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Circular arrows - continuous improvement */}
    <circle cx="60" cy="55" r="20" fill="none" stroke="#0f3b5e" strokeWidth="2.5" opacity="0.3"/>
    <circle cx="60" cy="55" r="14" fill="none" stroke="#0f3b5e" strokeWidth="2" opacity="0.2"/>
    
    {/* Upward trend arrow */}
    <path d="M35 72 L50 60 L62 68 L80 48" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M74 48 L80 48 L80 54" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* Progress dots */}
    <circle cx="50" cy="60" r="4" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="62" cy="68" r="4" fill="#0f3b5e" opacity="0.5"/>
    <circle cx="80" cy="48" r="4" fill="#22c55e" opacity="0.7"/>
    
    {/* KPI indicators */}
    <rect x="38" y="80" width="4" height="12" rx="1" fill="#0f3b5e" opacity="0.15"/>
    <rect x="46" y="76" width="4" height="16" rx="1" fill="#0f3b5e" opacity="0.25"/>
    <rect x="54" y="72" width="4" height="20" rx="1" fill="#0f3b5e" opacity="0.35"/>
    <rect x="62" y="68" width="4" height="24" rx="1" fill="#22c55e" opacity="0.4"/>
    <rect x="70" y="64" width="4" height="28" rx="1" fill="#22c55e" opacity="0.6"/>
    
    <text x="60" y="108" textAnchor="middle" fontSize="6" fill="#0f3b5e" fontWeight="bold">CONTINUOUS IMPROVEMENT</text>
  </svg>
);

// 8. Respect for People & Ecosystems
export const RespectSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="respGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0f3b5e" stopOpacity="0.1"/>
        <stop offset="100%" stopColor="#22c55e" stopOpacity="0.05"/>
      </linearGradient>
      <radialGradient id="respGrad2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#22c55e" stopOpacity="0.15"/>
        <stop offset="100%" stopColor="#22c55e" stopOpacity="0.02"/>
      </radialGradient>
    </defs>
    
    <circle cx="60" cy="60" r="55" fill="url(#respGrad)" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="none" stroke="#22c55e" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.3"/>
    
    {/* Person/community icon */}
    <circle cx="60" cy="40" r="10" fill="url(#respGrad2)" stroke="#0f3b5e" strokeWidth="2"/>
    <circle cx="60" cy="40" r="6" fill="#0f3b5e" opacity="0.1"/>
    <circle cx="60" cy="40" r="3" fill="#0f3b5e" opacity="0.3"/>
    
    {/* Body */}
    <path d="M45 55 C45 48 50 45 55 45 L65 45 C70 45 75 48 75 55 L75 65 L45 65 L45 55Z" 
          fill="#0f3b5e" opacity="0.06" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* People connecting - community */}
    <circle cx="35" cy="50" r="5" fill="#0f3b5e" opacity="0.1" stroke="#0f3b5e" strokeWidth="1"/>
    <circle cx="85" cy="50" r="5" fill="#0f3b5e" opacity="0.1" stroke="#0f3b5e" strokeWidth="1"/>
    <circle cx="35" cy="62" r="4" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="0.5"/>
    <circle cx="85" cy="62" r="4" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="0.5"/>
    
    {/* Ecosystem - trees/plants */}
    <path d="M20 78 L24 68 L28 78" stroke="#22c55e" strokeWidth="1.5" fill="none" opacity="0.5"/>
    <path d="M92 78 L96 68 L100 78" stroke="#22c55e" strokeWidth="1.5" fill="none" opacity="0.5"/>
    <path d="M26 70 L30 62 L34 70" stroke="#22c55e" strokeWidth="1" fill="none" opacity="0.3"/>
    <path d="M86 70 L90 62 L94 70" stroke="#22c55e" strokeWidth="1" fill="none" opacity="0.3"/>
    
    {/* Leaf accents */}
    <path d="M45 28 C48 24 52 24 55 28 C52 32 48 32 45 28Z" fill="#22c55e" opacity="0.2"/>
    <path d="M65 28 C68 24 72 24 75 28 C72 32 68 32 65 28Z" fill="#22c55e" opacity="0.2"/>
    
    {/* Heart representing care/respect */}
    <path d="M55 74 C50 68 52 62 58 64 C62 66 60 72 60 74 C60 72 62 66 66 64 C72 62 74 68 69 74 L60 82 L55 74Z" 
          fill="#22c55e" opacity="0.15" stroke="#22c55e" strokeWidth="1"/>
    
    <text x="60" y="108" textAnchor="middle" fontSize="6" fill="#0f3b5e" fontWeight="bold">RESPECT · PEOPLE · ECOSYSTEMS</text>
  </svg>
);